module.exports = require("skypager-util/lib/properties");


//////////////////
// WEBPACK FOOTER
// external "skypager-util/lib/properties"
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7 10 11